import { RouteObject } from "react-router-dom";
import { ExternalWebhookCreate } from "@/pages/admin/external-webhooks/ExternalWebhookCreate";
import { ExternalWebhookDetail } from "@/pages/admin/external-webhooks/ExternalWebhookDetail";
import { ExternalWebhookEdit } from "@/pages/admin/external-webhooks/ExternalWebhookEdit";
import { ExternalWebhooksList } from "@/pages/admin/external-webhooks/ExternalWebhooksList";

export const externalWebhooksRoutes: RouteObject[] = [
  {
    id: "external-webhooks-list",
    index: true,
    element: <ExternalWebhooksList />,
  },
  {
    id: "external-webhook-detail",
    path: ":id",
    element: <ExternalWebhookDetail />,
  },
  {
    id: "external-webhook-create",
    path: "create",
    element: <ExternalWebhookCreate />,
  },
  {
    id: "external-webhook-edit",
    path: ":id/edit",
    element: <ExternalWebhookEdit />,
  },
];
